export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/367d2948d3ecc1459e5c7207f173742a.png";